/** Stable primary work areas assigned by the footprint estimator or an operator. */
export const WORK_CATEGORIES = [
  'gameplay',
  'graphics',
  'ui',
  'input',
  'audio',
  'performance',
  'platform',
  'hygiene',
  'unclassified',
] as const;

export type WorkCategory = (typeof WORK_CATEGORIES)[number];

export const WORK_CATEGORY_LABELS: Record<WorkCategory, string> = {
  gameplay: 'Gameplay and systems',
  graphics: 'Graphics and rendering',
  ui: 'UI and experience',
  input: 'Input and controls',
  audio: 'Audio',
  performance: 'Performance',
  platform: 'Platform and integration',
  hygiene: 'Project hygiene',
  unclassified: 'Unclassified',
};

export function isWorkCategory(value: unknown): value is WorkCategory {
  return typeof value === 'string' && (WORK_CATEGORIES as readonly string[]).includes(value);
}
